import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/racq-icon-sm.svg'
import _imports_1 from '@/assets/icons/racq-icon-lg.svg'
import _imports_2 from '@/assets/icons/close-icon.svg'
import _imports_3 from '@/assets/icons/logout-icon.svg'


const _hoisted_1 = { class: "flex justify-between p-4" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "grow flex flex-col justify-between px-4 pb-10 md:px-6 md:pt-6 md:pb-0 md:mt-2" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "block w-14 h-14 text-center rounded-2xl border border-racq-blue-border group-hover:border-racq-blue-active bg-racq-anti-flash-white mx-auto" }
const _hoisted_7 = { class: "text-xl2 tracking-[-0.48px] !leading-[56px] py-[1px] px-2" }
const _hoisted_8 = ["alt"]
const _hoisted_9 = { class: "text-xl-bold lg:text-base-bold text-racq-dark-grey group-hover:text-racq-blue-active" }
const _hoisted_10 = { class: "text-base lg:text-m text-racq-grey text-center mb-6 lg:mb-5" }
const _hoisted_11 = ["data-test-id"]
const _hoisted_12 = {
  class: "my-8 md:mb-6 flex flex-col gap-1",
  "data-test-id": "primary-menu-items"
}
const _hoisted_13 = {
  key: 0,
  class: "text-lg-bold lg:text-m-bold text-racq-dark-grey pt-1"
}
const _hoisted_14 = { class: "my-8 md:my-6 px-2 flex flex-col gap-3 md:gap-4" }
const _hoisted_15 = { class: "sticky md:pb-6 md:bottom-0 bg-racq-true-white" }

import { Item, Field } from '@sitecore-jss/sitecore-jss/types/layout';
import { Image, isEditorActive, Link, Text } from '@sitecore-jss/sitecore-jss-vue';
import { ImageFieldValue } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { ref, computed, onMounted } from 'vue';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';
import { useAccountStore } from '@/store';
import { format } from 'date-fns';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------
const SCROLLBAR_HIDE_DELAY = 500;

// Get primary menu item index

export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationPanel',
  props: {
    menuClasses: {},
    homeLink: {},
    profileLink: {},
    title: {},
    subtitle: {},
    primaryButton: {},
    secondaryButton: {},
    logoutButton: {},
    toggleMenu: { type: Function },
    primaryMenuItems: {},
    secondaryMenuItems: {},
    onSecondaryClick: { type: Function }
  },
  setup(__props: any) {

const props = __props;

let activeMenuItem = props.primaryMenuItems.findIndex(
  (item) => (item.fields?.link as LinkField)?.value?.href?.toLowerCase() == window.location.pathname.toLowerCase()
);
// Store to browser session for product details page
if (activeMenuItem != -1) {
  sessionStorage.activeMenuItem = activeMenuItem;
} else {
  activeMenuItem = sessionStorage.activeMenuItem ?? 0;
}

const accountStore = useAccountStore();
const scrollbarIsHidden = ref<boolean>(false);

const title = computed(() => (isEditorActive() ? 'Alex Smith' : props.title));

const subtitleLabel = computed(() => {
  if (!accountStore.identityDetails?.membershipJoined) return '';
  return props.subtitle.replace('{{joinYear}}', format(accountStore.identityDetails?.membershipJoined, 'yyyy'));
});

onMounted(() => {
  setTimeout(() => {
    scrollbarIsHidden.value = true;
  }, SCROLLBAR_HIDE_DELAY);
});

const handleScroll = () => {
  scrollbarIsHidden.value = false;
};

const handleScrollEnd = () => {
  setTimeout(() => {
    scrollbarIsHidden.value = true;
  }, SCROLLBAR_HIDE_DELAY);
};

const logout = () => {
  accountStore.logout();
};

/**
 * Format adobe target data test id
 * @param label
 * @param options
 * @returns
 */
const adobeTargetId = (
  label?: string,
  options?: {
    prefix?: string;
    suffix?: string;
  }
) => {
  return [options?.prefix, ...(label?.toLowerCase()?.split(' ') ?? []), options?.suffix].filter((o) => o).join('_');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "self-service-menu-drawer",
    class: _normalizeClass([
      'flex flex-col justify-stretch transition-all bg-racq-true-white w-[85%] lg:w-[304px] max-w-[356px] md:max-w-lg h-screen-dynamic lg:h-screen max-h-screen-dynamic lg:min-h-screen lg:max-h-none border-r border-light-grey z-70 top-0 absolute lg:sticky overflow-y-scroll lg:overflow-y-auto lg:flex-shrink-0 scrollbar-thin',
      _ctx.menuClasses,
      {
        'scrollbar-racq': !scrollbarIsHidden.value,
        'scrollbar-transparent': scrollbarIsHidden.value,
      },
    ]),
    onScroll: handleScroll,
    onScrollend: handleScrollEnd
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: _ctx.homeLink?.value.href ?? '/',
        class: "lg:hidden"
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          src: _imports_0,
          height: "20",
          width: "48",
          class: "h-[20px]",
          alt: "racq-icon"
        }, null, -1)
      ]), 8, _hoisted_2),
      _createElementVNode("a", {
        href: _ctx.homeLink?.value.href ?? '/',
        class: "hidden lg:block"
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("img", {
          src: _imports_1,
          height: "22",
          width: "56",
          class: "h-[22px]",
          alt: "racq-icon"
        }, null, -1)
      ]), 8, _hoisted_3),
      _createElementVNode("img", {
        src: _imports_2,
        height: "24",
        width: "24",
        alt: "close-icon",
        class: "block lg:hidden",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: _ctx.profileLink?.value.href ?? '#',
          class: "group flex flex-col gap-4 lg:gap-3 no-underline text-center w-full mt-1 lg:mt-6"
        }, [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(title.value
                  .split(' ')
                  .map((n) => n.charAt(0))
                  .join('')), 1),
            _withDirectives(_createElementVNode("img", {
              src: "#",
              alt: `${title.value}`,
              class: "w-14 h-14"
            }, null, 8, _hoisted_8), [
              [_vShow, false]
            ])
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(title.value), 1)
        ], 8, _hoisted_5),
        _createElementVNode("div", _hoisted_10, _toDisplayString(subtitleLabel.value), 1),
        _createElementVNode("button", {
          class: "btn btn-md lg:btn-sm btn-primary w-full",
          "data-test-id": adobeTargetId(_ctx.secondaryButton, { suffix: 'sidebar' }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (props.onSecondaryClick?.()))
        }, _toDisplayString(_ctx.secondaryButton), 9, _hoisted_11),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryMenuItems, (item, index) => {
            return (_openBlock(), _createBlock(_unref(Link), {
              key: index,
              field: item.fields.link,
              "data-test-id": adobeTargetId(item.fields?.link?.value?.text, { suffix: 'sidebar' }),
              class: _normalizeClass(["flex gap-2 p-2 w-full hover:bg-racq-anti-flash-white active:bg-racq-white active:no-underline transition no-underline rounded-lg focus:rounded-lg", {
              'bg-racq-neutral-grey': index == _unref(activeMenuItem),
            }])
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Image), {
                  media: (item.fields.icon as Field<ImageFieldValue>)?.value,
                  editable: true
                }, null, 8, ["media"]),
                (!_unref(isEditorActive)())
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(item.fields.link?.value.text), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["field", "data-test-id", "class"]))
          }), 128))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "border-racq-white my-8" }, null, -1)),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondaryMenuItems, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex gap-2"
            }, [
              _createVNode(_unref(Link), {
                field: item.fields.link,
                class: "text-m-bold text-racq-grey no-underline hover:!underline hover:!decoration-[10%]",
                "data-test-id": adobeTargetId(item.fields?.link?.value?.text, { suffix: 'sidebar' })
              }, null, 8, ["field", "data-test-id"])
            ]))
          }), 128))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "border-racq-white mt-6 md:hidden" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-secondary w-full mt-8 sticky bottom-0",
          onClick: logout
        }, [
          _createTextVNode(_toDisplayString(_ctx.logoutButton) + " ", 1),
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: _imports_3,
            alt: "logout-icon"
          }, null, -1))
        ])
      ])
    ])
  ], 34))
}
}

})